import type { CurrentPrice } from "@/types/price"
import client from "./client"

export async function getCurrentPrices(codes: string[]): Promise<CurrentPrice[]> {
  if (codes.length === 0) return []
  const { data } = await client.get<CurrentPrice[]>("/api/prices/current", {
    params: { codes: codes.join(",") },
  })
  return data
}
